// Colors for different vegetables
export const vegetableColors = {
    Potato: '#e0c04a',
    Carrot: '#f58634',
    Broccoli: '#43a047',
    Tomato: '#d32f2f',
    Corn: '#fdd835',
    default: '#a5d6a7'
};

export const MIN_ZOOM = 0.5; // Example: Zoom in limit (closer)
export const MAX_ZOOM = 2.0; // Example: Zoom out limit (further)
export const ZOOM_SENSITIVITY = 0.001; // Adjust for mouse wheel sensitivity
export const PINCH_SENSITIVITY = 0.015; // Slightly increased sensitivity
export const DEFAULT_LOOK_SENSITIVITY = 0.005; // 0.005 works well for mobiles at least


export const WEBSOCKET_URL = 'wss://ws.beaveg.com/ws'; // Or get from config/env